import {Avatar, Box, Card, Divider, Grid, Stack, Typography} from '@mui/material';
import {useBoardRedux, useSprintsRedux} from 'hooks';
import {useGetTicketBoardUserInfoReportApi} from 'hooks/reports';
import {formatSecondsToTime} from 'models';
import {useEffect} from 'react';

// Helper to get initials from a name
const getInitials = (name: string) => {
    return name
        ?.split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
};

export const UserTicketAssignmentReportBoardView = () => {
    const {selectedBoard} = useBoardRedux();
    const {selectedSprint} = useSprintsRedux();
    const {getTicketBoardUserInfoReport, getTicketBoardUserInfoReportResponse} = useGetTicketBoardUserInfoReportApi();
    useEffect(() => {
        if (selectedBoard) {
            getTicketBoardUserInfoReport({
                variables: {
                    boardId: selectedBoard.id,
                    sprintId:
                        selectedSprint?.id !== undefined && selectedSprint?.id !== '' ? selectedSprint?.id : undefined,
                },
            });
        }
    }, [selectedBoard, selectedSprint]);

    return (
        <Card
            sx={{
                p: 2,

                boxShadow: 2,
                width: '100%',
                mb: 3,
                minHeight: 'calc(100vh - 185px)',
            }}
        >
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start" flexWrap="wrap" mb={2}>
                <Stack direction="row" spacing={0.5} alignItems="center" minWidth={120}>
                    <Typography variant="caption" color="text.secondary">
                        Total Tickets:
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="primary.main">
                        {getTicketBoardUserInfoReportResponse?.totalTickets ?? '...'}
                    </Typography>
                </Stack>

                <Stack direction="row" spacing={0.5} alignItems="center" minWidth={120}>
                    <Typography variant="caption" color="text.secondary">
                        Unassigned Tickets
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="error.main">
                        {getTicketBoardUserInfoReportResponse?.unAssignedTickets ?? '...'}
                    </Typography>
                </Stack>
            </Stack>

            <Divider sx={{mb: 2}} />

            <Grid container spacing={1}>
                {getTicketBoardUserInfoReportResponse?.userInfo.map(user => (
                    <Grid item xs={12} lg={3} sm={4} md={3} key={user.userId}>
                        <Box
                            sx={{
                                p: 1.5,
                                border: '1px solid #eee',
                                height: '100%',
                            }}
                        >
                            <Stack direction="row" spacing={1} mb={1} alignItems="center">
                                <Avatar
                                    sx={{
                                        bgcolor: 'primary.main',
                                        width: 38,
                                        height: 38,
                                        fontSize: 14,
                                        fontWeight: 600,
                                    }}
                                >
                                    {getInitials(user.userName)}
                                </Avatar>
                                <Box>
                                    <Typography variant="subtitle2" fontWeight={600}>
                                        {user.userName}
                                    </Typography>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        Assigned: {user.totalAssignendTickets}
                                    </Typography>
                                </Box>
                            </Stack>

                            <Box display="flex" justifyContent="space-between" mb={0.5}>
                                <Typography variant="caption" color="text.secondary">
                                    Est. Hours
                                </Typography>
                                <Typography variant="caption" fontWeight={600} color="success.main">
                                    {user.totalEstimatedHours?.toFixed(1)}
                                </Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between">
                                <Typography variant="caption" color="text.secondary">
                                    Tracker Hours
                                </Typography>
                                <Typography variant="caption" fontWeight={600} color="success.main">
                                    {formatSecondsToTime(user.totalTrackerHours)}
                                </Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between">
                                <Typography variant="caption" color="text.secondary">
                                    Spent Hours (Manual Enty)
                                </Typography>
                                <Typography variant="caption" fontWeight={600} color="success.main">
                                    {formatSecondsToTime(user.totalHoursSpended)}
                                </Typography>
                            </Box>

                            <Box display="flex" justifyContent="space-between">
                                <Typography variant="caption" color="text.secondary">
                                    Total Spent Hours
                                </Typography>
                                <Typography variant="caption" fontWeight={600} color="success.main">
                                    {formatSecondsToTime(user.totalTrackerHours + user.totalHoursSpended)}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Card>
    );
};

export default UserTicketAssignmentReportBoardView;
